import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { LangService } from "@app/services/lang.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { PaymentWrapComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-payment-client-fail-grow",
	imports: [COMMON_IMPORTS, PaymentWrapComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-payment-wrap>
			<h2>{{ "payment_failed" | langVal }}</h2>
			<br />
			<h3>{{ "payment_failed1" | langVal }}</h3>
			<br />
		</app-payment-wrap>
	`,
})
export class PaymentClientFailGrowComponent implements OnInit {
	success: boolean = false //was the purchase a success
	constructor(public lang: LangService) {}

	ngOnInit() {
		let input = location.search.split("?").pop() //gets the query string (everything in the URL after the ? sign)
	}
}
